<template>
  <div class="flex items-center">
    <label :id="inputName" v-if="showLabel" class="mr-4" for="qty">QTY</label>

    <button type="button" class="text-orange" @click="qty--" role="button" aria-label="decrease quantity">
      <svg class="minus-dims w-3 h-3">
        <use xlink:href="#minus"></use>
      </svg>
    </button>

    <input
      class="font-sans text-lg text-center border-0 border-b border-orange w-8 mx-2 px-2 pb-0"
      v-model.number="qty"
      type="text"
      :name="inputName"
      min="1"
      :aria-labelledby="showLabel ? inputName : false"
      :aria-label="!showLabel ? inputName : false">

    <button type="button" class="text-orange" @click="qty++" role="button" aria-label="increase quantity">
      <svg class="plus-dims w-3 h-3">
        <use xlink:href="#plus"></use>
      </svg>
    </button>
  </div>
</template>

<script>
import { EventBus } from "../../lib/event-bus.js"

export default {
  props: {
    itemQty: {
      type: Number,
      default: 1
    },
    showLabel: {
      default: true
    },
    inputName: {
      type: String,
      default: 'qty'
    }
  },

  data() {
    return {
      qty: this.itemQty
    }
  },

  watch: {
    qty(newVal, oldVal) {
      if (newVal <= 0) {
        this.qty = 1
      }

      this.$emit('qty-update', this.qty)
    }
  }
}
</script>



// WEBPACK FOOTER //
// _js/components/shop/QtyInput.vue